<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12 footer d-flex align-items-center justify-content-center">
            <a href="" class="fb"></a>
            <a href="" class="insta"></a>
            <a href="" class="mail"></a>
            <a href="" class="phone"></a>            
        </div>
    </div>
</div>